import React from 'react'

import Bredcom from '../Bredcrumb/Main'
import RamenMenu from '../Allmenus/FirstMenu/Ramen';
import NikumanMenu from '../Allmenus/FirstMenu/Nikuman';
import ToppingMenu from '../Allmenus/FirstMenu/Topping';
import MeatMenu from '../Allmenus/FirstMenu/Meat'

import SeaFoodMenu from '../Allmenus/Seafood'
import VegetableMenu from '../Allmenus/Vegetable'
import RiceMenu from '../Allmenus/Rice'
import DesertMenu from '../Allmenus/Dessert'

import Img from '../../assets/images/background/banner-image-2.jpg'

function Main() {
  return (
    <>
      <Bredcom subtitle="Food" title="" Img={Img} />
      <RamenMenu />
      <ToppingMenu />
      <NikumanMenu />
      <MeatMenu />
      <SeaFoodMenu />
      <VegetableMenu />
      <RiceMenu />
      <DesertMenu />
    </>
  )
}

export default Main
